import { Component } from '@angular/core';
import {
  ChargeInformationService,
  DataHubStatus,
  ChargeInformationDto,
  QueryChargeInformationDto
} from '@app/api/dmc';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { HeaderService } from '@app/core/services/header.service';
import {TableComponent} from '@shared/components/table/table.component';
import { queryDashboardConfig } from '@views/dashboard/config/query.dashboard-config';

@Component({
  selector: 'app-dashboard-chargeinformation-rejected',
  imports: [
    TableComponent
  ],
  templateUrl: './dashboard-chargeinformation-rejected.component.html',
  styleUrl: './dashboard-chargeinformation-rejected.component.css'
})
export class DashboardChargeinformationRejectedComponent {
  public tableData: ChargeInformationDto[] = [];
  public tableConfig: TableConfig<ChargeInformationDto> =
    queryDashboardConfig['chargeinformationrejected'].tableConfig as TableConfig<ChargeInformationDto>;

  public selectedElements: ChargeInformationDto[] = [];

  constructor(
    private readonly headerService: HeaderService,
    private readonly chargeInformationService: ChargeInformationService,
  ) {
    this.headerService.setTitle('dashboard.query.rejectedchargeinformation.title');

    this.fetchData();
  }

  public fetchData(): void {
    const dto: QueryChargeInformationDto = {
      dataHubStatus: DataHubStatus.Rejected,
      latest: true,
      excludeToDoHandled: true
    };

    this.chargeInformationService.chargeInformationQueryPost(dto).subscribe(
      (result: any) => {
        this.tableData = result.results || [];
      }
    )
  }
}
